import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import numerologistPortrait from "../../../assets/images/life-journey/numerologist-portrait.jpg";

const WhyChooseUs = () => {
  const benefits = [
    {
      title: "Trusted Expert Guidance",
      description: "Acharya Lav Bhushan has many years of experience. His advice helps you understand your match clearly. The platform makes Kundali Milan easy and useful."
    },
    {
      title: "Fast & Accurate Match Check",
      description: "The system uses proven Ashtakoot and Dashakoot methods to check compatibility. These time-tested methods give correct and reliable results."
    },
    {
      title: "Available Anytime, Anywhere",
      description: "No need to visit an astrologer in person. Just enter your details online and get your Kundali match quickly, anytime, 24/7."
    },
    {
      title: "Safe & Private",
      description: "Your personal details stay private. All reports are shared securely."
    },
    {
      title: "Talk to Acharya Lav Bhushan’s Team",
      description: "If you need more clarity or have questions, you can book a one-on-one session with a Senior Astrologer trained by Acharya Lav Bhushan."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-red-900 via-red-800 to-orange-600">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Book Image */}
          <div className="flex justify-center">
            <div className="relative">
              <img 
                src={numerologistPortrait}
                alt="Couple Matching Kundli Book by Astro Acharya Lav Bhushan"
                className="max-w-md w-full h-auto rounded-lg shadow-2xl"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-8">
            <div className="text-center lg:text-left">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
                Why Choose Online Kundali Matching with Acharya Lav Bhushan?
              </h2>
              <p className="text-xl text-orange-100 leading-relaxed mb-4">
                Marriage is a lifelong promise, and knowing if two people are compatible is very important. With the help of Acharya Lav Bhushan, a Celebrity Astrologer, you can easily match Kundali online with accurate and trusted results.
              </p>
              <p className="text-lg text-orange-200 mb-8">
                Here’s why this service is the right choice:
              </p>
            </div>

            <div className="space-y-4">
              {benefits.map((benefit, index) => (
                <Card key={index} className="bg-white/95 backdrop-blur-sm border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                  <CardHeader className="pb-3">
                    <CardTitle className="text-lg font-bold text-red-800">
                      {benefit.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pt-0">
                    <p className="text-gray-700 text-sm leading-relaxed">
                      {benefit.description}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;